<template>
    <div>
        <div class="box-rules">
            <p>
                Le mot de passe doit comporter <strong>12 caractères minimum</strong> avec, au moins : 
                <strong>1 majuscule</strong>, <strong>1 minuscule</strong>, <strong>1 chiffre</strong> et <strong>1 caractère spécial</strong>
            </p>
        </div>
        
        <resource-form :model="form.model"
            :schema="form.schema"
            :triggers="form.triggers"
            :no-form-group="true"
            @submit="onFormSubmit">
            <button type="button" slot="cancel" class="btn btn-default btn-sm" @click="onCancelButtonClick">
                Annuler
            </button>
        </resource-form>
    </div>
</template>

<script>
    import ResourceForm from "components/Forms/ResourceForm"

    export default {
        data() {
            return {
                form: {
                    model: {},
                    schema: {
                        fields: [
                            {
                                "type": "password",
                                "label": "Mot de passe",
                                "model": "password",
                                "readonly": false,
                                "placeholder": "******",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": true
                            },
                            {
                                "type": "password",
                                "label": "Confirmation du mot de passe",
                                "model": "password_confirmation",
                                "readonly": false,
                                "placeholder": "******",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": true
                            }
                        ],
                        optional_fields: []
                    },
                    triggers: {}
                }
            }
        },

        props: {
            user: {
                required: true
            }
        },

        components: {
            ResourceForm
        },

        methods: {
            updateUserPassword(payload) {
                return this.$root.axios.put(`users/${this.user.id}/update_password`, payload)
            },

            onFormSubmit({ data: model }) {
                this.updateUserPassword(model)
                    .then(() => {
                        this.$emit('password-updated')
                
                        // For modal handling
                        this.$parent.$emit('modal-closed')
                    })
            },

            onCancelButtonClick() {
                this.$emit('operation-canceled')
                
                // For modal handling
                this.$parent.$emit('modal-closed')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .box-rules {
        background-color: #d9edf7;
        padding: 10px;
        margin-bottom: 10px;

        p {
            margin-bottom: 5px;
        }

        ul {
            padding-left: 15px;
            
            li {
                list-style: disc inside;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// client/components/Users/UserPasswordUpdateForm.vue